import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PartnerPicker } from "./PartnerPicker";

export function BulkAssign({ ids, onDone, onClear, onAll }) {
  const [busy, setBusy] = useState(false);
  const save = async (partner_id) => {
    setBusy(true);
    try {
      const r = await api.put("/monitoring/plants-partner", { ids, partner_id });
      toast.success(`${r.data.trovati} impianti ${partner_id ? "associati" : "senza abbinamento manuale"}`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    setBusy(false);
  };
  return (
    <div className="sticky top-2 z-40 flex flex-wrap items-center gap-3 rounded-xl border border-sky-500/40 bg-neutral-950/95 px-3 py-2 text-xs text-neutral-300 backdrop-blur" data-testid="bulk-assign-bar">
      <b className="text-white" data-testid="bulk-assign-count">{ids.length} selezionati</b>
      <button type="button" onClick={onAll} className="text-neutral-400 underline-offset-2 hover:text-white hover:underline" data-testid="bulk-assign-all">Seleziona tutti i visibili</button>
      <div className={`ml-auto flex flex-wrap items-center gap-2 ${busy ? "pointer-events-none opacity-50" : ""}`}>
        <PartnerPicker value={null} onPick={save} testid="bulk-partner-picker" />
        <button type="button" onClick={() => save(null)} className="rounded-full border border-neutral-700 px-3 py-1 text-neutral-300 hover:border-red-400 hover:text-red-400" data-testid="bulk-assign-reset">Rimuovi abbinamento</button>
        <button type="button" onClick={onClear} className="text-neutral-500 hover:text-white" data-testid="bulk-assign-clear" title="Annulla selezione"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
